import { render, staticRenderFns } from "./dimensionModal.vue?vue&type=template&id=1704b5ee&scoped=true"
import script from "./dimensionModal.vue?vue&type=script&lang=js"
export * from "./dimensionModal.vue?vue&type=script&lang=js"
import style0 from "./dimensionModal.vue?vue&type=style&index=0&id=1704b5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704b5ee",
  null
  
)

export default component.exports